import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { extraStore } from '@/stores/v2/extra'
import WoononExtraProduct from '@/components/v2/extra/WoononExtraProduct.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WoononExtraProductsDesktop',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, { "tab-position": "left" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extraStore)().elements, (element) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          tab: element.commercial_name,
          class: "extra-tabs",
          key: element.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              gutter: [16,16],
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    (element.commercial_description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "mb-16",
                          innerHTML: element.commercial_description
                        }, null, 8, _hoisted_1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.products, (product) => {
                          return (_openBlock(), _createBlock(_component_a_col, {
                            span: 24,
                            key: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(WoononExtraProduct, {
                                store: _unref(extraStore)(),
                                product: product,
                                isConfigurable: element.is_configurable_by_customer
                              }, null, 8, ["store", "product", "isConfigurable"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["tab"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})